var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobeOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6270_304794)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00049 0.832031C11.9584 0.832207 15.1665 4.04109 15.1665 7.99902C15.1663 11.9568 11.9583 15.1649 8.00049 15.165C4.04256 15.165 0.833672 11.9569 0.833496 7.99902C0.833496 4.04098 4.04245 0.832031 8.00049 0.832031ZM1.85596 8.49902C2.08023 11.2907 4.16202 13.5556 6.86572 14.0586C5.69021 12.4345 4.99021 10.509 4.85596 8.49902H1.85596ZM11.144 8.49902C11.0099 10.5091 10.3098 12.4344 9.13428 14.0586C11.8382 13.5558 13.9198 11.2909 14.144 8.49902H11.144ZM5.85889 8.49902C6.00462 10.475 6.75172 12.3585 7.99951 13.8965C9.24761 12.3584 9.99445 10.4752 10.1401 8.49902H5.85889ZM9.1333 1.9375C10.3097 3.56215 11.011 5.48803 11.145 7.49902H14.144C13.9199 4.70651 11.8378 2.44001 9.1333 1.9375ZM7.99951 2.10059C6.75148 3.6388 6.00449 5.52273 5.85889 7.49902H10.1401C9.99457 5.52255 9.24784 3.63891 7.99951 2.10059ZM6.8667 1.9375C4.16235 2.44024 2.08012 4.70672 1.85596 7.49902H4.85498C4.98911 5.48811 5.69024 3.56206 6.8667 1.9375Z",
    fill: "#326AC2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6270_304794"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeOutline);
export default __webpack_public_path__ + "static/media/globe-outline.ac8cb73348af3fa46ba1f210eef06d9b.svg";
export { ForwardRef as ReactComponent };